<template>
  <div class="home-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-notice-bar v-if="notice_text != ''" background="#f0dadc" color="black" left-icon="volume-o"
                      :text="notice_text" />
      <van-tabs swipe-threshold='3' @click='selects' :active="active" shrink>
        <van-tab title="商超代金券">
          <van-tabs @click='selectShopStatus' class='navtab' title-active-color='black' v-model="fyActives" animated>
            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">
              <van-list v-model="shopLoading" :finished="shopFinished" finished-text="没有更多了" :immediate-check="false"
                        @load="hyLoadings">
                <div v-for="(i,ind) in shopList" :key="ind" class="qy-content qy-fen">
                  <div class="qy-content-img">
                    <img :src="i.couponLogo">
                  </div>
                  <div class="qy-content-info">
                    <span>{{ i.couponName }}</span>
                    <span class="transaction">{{ i.couponUseDesc }}</span>
                    <span style="color:#CB4643;">{{ i.endTime }}</span>
                  </div>
                  <div v-show="i.status === 0" class="qy-button  qy-button-fen" @click="hyActivated(i.userCouponId,i.activatedType)">
                    <span>激活</span>
                  </div>
                  <div v-show="i.status === 1 && (!i.startTime || i.startTime==='')" class="qy-button  qy-button-fen">
                    <span>激活中</span>
                  </div>
                  <div v-show="i.status != 0" style='position: absolute;right: 0.3rem;top: 0.3rem;'>
                    <img v-show="i.status === 0" style="width: 2rem;" src="../../assets/img2/wjh.png">
                    <img v-show="i.status === 1 && i.startTime && i.startTime!==''" style="width: 2rem;" src="../../assets/img2/yjh.png">
                    <!--                    <img v-show="i.status === 1 && (!i.startTime || i.startTime!=='')" style="width: 2rem;" src="../../assets/img2/yjh.png">-->
                    <img v-show="i.status === 2" style="width: 2rem;" src="../../assets/img2/ysy.png">
                  </div>
                </div>
              </van-list>
            </van-tab>
          </van-tabs>
        </van-tab>


        <van-tab title="出行会员">
          <van-tabs @click='selectfyStatus' class='navtab' title-active-color='black' v-model="fyActives" animated>
            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">
              <van-list v-model="hyLoading" :finished="hyFinished" finished-text="没有更多了" :immediate-check="false"
                        @load="hyLoadings">
                <div v-for="(i,ind) in hyList" :key="ind" class="qy-content qy-fen">
                  <div class="qy-content-img">
                    <img :src="i.couponLogo">
                  </div>
                  <div class="qy-content-info">
                    <span>{{ i.couponName }}</span>
                    <span class="transaction">{{ i.couponUseDesc }}</span>
                    <span style="color:#CB4643;">{{ i.endTime }}</span>
                  </div>
                  <div v-show="i.status === 0" class="qy-button  qy-button-fen" @click="hyActivated(i.userCouponId,i.activatedType)">
                    <span>激活</span>
                  </div>
                  <div v-show="i.status != 0" style='position: absolute;right: 0.3rem;top: 0.3rem;'>
                    <img v-show="i.status === 0" style="width: 2rem;" src="../../assets/img2/wjh.png">
                    <img v-show="i.status === 1" style="width: 2rem;" src="../../assets/img2/yjh.png">
                    <img v-show="i.status === 2" style="width: 2rem;" src="../../assets/img2/ysy.png">
                  </div>
                </div>
              </van-list>
            </van-tab>
          </van-tabs>
        </van-tab>



        <van-tab title="美食会员">
          <van-tabs @click='selectMsStatus' class='navtab' title-active-color='black' v-model="fyActives" animated>
            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">
              <van-list v-model="hyLoading" :finished="hyFinished" finished-text="没有更多了" :immediate-check="false"
                        @load="hyLoadings">
                <div v-for="(i,ind) in hyList" :key="ind" class="qy-content qy-fen">
                  <div class="qy-content-img">
                    <img :src="i.couponLogo">
                  </div>
                  <div class="qy-content-info">
                    <span>{{ i.couponName }}</span>
                    <span class="transaction">{{ i.couponUseDesc }}</span>
                    <span style="color:#CB4643;">{{ i.endTime }}</span>
                  </div>
                  <div v-show="i.status === 0" class="qy-button  qy-button-fen" @click="hyActivated(i.userCouponId,i.activatedType)">
                    <span>激活</span>
                  </div>
                  <div v-show="i.status != 0" style='position: absolute;right: 0.3rem;top: 0.3rem;'>
                    <img v-show="i.status === 0" style="width: 2rem;" src="../../assets/img2/wjh.png">
                    <img v-show="i.status === 1" style="width: 2rem;" src="../../assets/img2/yjh.png">
                    <img v-show="i.status === 2" style="width: 2rem;" src="../../assets/img2/ysy.png">
                  </div>
                </div>
              </van-list>
            </van-tab>
          </van-tabs>
        </van-tab>

        <van-tab title="30元会员">
          <van-tabs @click='selectMsStatus' class='navtab' title-active-color='black' v-model="fyActives" animated>
            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">
              <van-list v-model="hyLoading" :finished="hyFinished" finished-text="没有更多了" :immediate-check="false"
                        @load="hyLoadings">
                <div v-for="(i,ind) in hyList" :key="ind" class="qy-content qy-fen">
                  <div class="qy-content-img">
                    <img :src="i.couponLogo">
                  </div>
                  <div class="qy-content-info">
                    <span>{{ i.couponName }}</span>
                    <span class="transaction">{{ i.couponUseDesc }}</span>
                    <span style="color:#CB4643;">{{ i.endTime }}</span>
                  </div>
                  <div v-show="i.status === 0" class="qy-button  qy-button-fen" @click="hyActivated(i.userCouponId,i.activatedType)">
                    <span>激活</span>
                  </div>
                  <div v-show="i.status != 0" style='position: absolute;right: 0.3rem;top: 0.3rem;'>
                    <img v-show="i.status === 0" style="width: 2rem;" src="../../assets/img2/wjh.png">
                    <img v-show="i.status === 1" style="width: 2rem;" src="../../assets/img2/yjh.png">
                    <img v-show="i.status === 2" style="width: 2rem;" src="../../assets/img2/ysy.png">
                  </div>
                </div>
              </van-list>
            </van-tab>
          </van-tabs>
        </van-tab>
        <van-tab title="50元会员">
          <van-tabs @click='selectMsStatus' class='navtab' title-active-color='black' v-model="fyActives" animated>
            <van-tab v-for="(item,ind) in navlist" :key="ind" :title="item.name">
              <van-list v-model="hyLoading" :finished="hyFinished" finished-text="没有更多了" :immediate-check="false"
                        @load="hyLoadings">
                <div v-for="(i,ind) in hyList" :key="ind" class="qy-content qy-fen">
                  <div class="qy-content-img">
                    <img :src="i.couponLogo">
                  </div>
                  <div class="qy-content-info">
                    <span>{{ i.couponName }}</span>
                    <span class="transaction">{{ i.couponUseDesc }}</span>
                    <span style="color:#CB4643;">{{ i.endTime }}</span>
                  </div>
                  <div v-show="i.status === 0" class="qy-button  qy-button-fen" @click="hyActivated(i.userCouponId,i.activatedType)">
                    <span>激活</span>
                  </div>
                  <div v-show="i.status != 0" style='position: absolute;right: 0.3rem;top: 0.3rem;'>
                    <img v-show="i.status === 0" style="width: 2rem;" src="../../assets/img2/wjh.png">
                    <img v-show="i.status === 1" style="width: 2rem;" src="../../assets/img2/yjh.png">
                    <img v-show="i.status === 2" style="width: 2rem;" src="../../assets/img2/ysy.png">
                  </div>
                </div>
              </van-list>
            </van-tab>
          </van-tabs>
        </van-tab>
      </van-tabs>


      <van-popup v-model="showMobileBtn"  :close-on-click-overlay="false" round position="center" :style="{width: '85%', height: '20%' }">
        <div style="padding: 1rem 0;">

          <van-field v-model="tel" type="tel" center clearable label="手机号" placeholder="请输入手机号">
            <template #button>
              <van-button @click='onTelSet' size="small" type="primary">确定</van-button>
            </template>
          </van-field>

        </div>
      </van-popup>

    </van-pull-refresh>
  </div>
</template>

<script>
import {
  getHyUserCoupons,
  wtdecrypt,
  getToken,
  getuserInfo,
  getOauth2AccessTokenNew,
  getTokenByOpenid,
  fyActivatedCoupon,
  getNotice,
} from "@/api/user";
import { Dialog, Toast } from "vant";
import { mapState } from "vuex";
import { getItem } from "@/utils/storage";
import wxApi from "@/api/wxapi";

import { isWXBrowser, getWechatCode } from "@/api/getcode";
export default {
  name: "home",

  props: {},
  data() {
    return {
      tel:'',
      showMobileBtn:false,
      notice_text: "",
      openid: "",
      htOpenId: "",
      active: 0, //被激活的列表
      actives: 0, //被激活的列表
      activess: 0, //被激活的列表
      navlist: [
        {
          name: "未使用",
        },
        {
          name: "已使用",
        },
        {
          name: "已失效",
        },
      ],
      enterpriseType: "0",
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      from: 0,
      status: 0,
      hyLoading: false,
      hyFinished: false,
      shopLoading: false,
      shopFinished: false,
      fyActives: 0, //被激活的列表
      fyFrom: 0,
      size: 10,
      hyStatus: 0, //状态 0-未使用 2-已使用 3-已失效
      hyList: [],
      shopList: [],
      couponGroup: 2, // 所属产品模块 0-缴费宝 1-车主 2-商超
      jump:''
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {},
  async created() {
    const hashParams =this.parseHashParams();

    console.log('jump=======',hashParams.jump);
    console.log('openId=======',hashParams.openId);
    console.log('userInfo=======',hashParams.userInfo);
    if (isWXBrowser) {

      if(hashParams.jump==='1'){
        if(!hashParams.openId||hashParams.openId===''){
          //跳转恒通
          var baseUrl = window.location.href;
          var hrefUrl = 'https://mp.ebeeweb.cn/#/pages/auth/auth?base_uri='+encodeURIComponent(baseUrl);

          console.log('跳转恒通',hrefUrl)
          window.location.href = hrefUrl;
          return;
        } else {
          this.htOpenId = hashParams.openId;
          console.log('回调结束', this.htOpenId)
        }
      }
      const storedOpenId = localStorage.getItem('openId');
      if (storedOpenId) {
        this.openid = storedOpenId;
      } else {
        var code = getWechatCode();
        if (!code) {
          return;
        }
        await this.getopenid(code);
      }

      const hasLogin = await this.loginByOpenid();
      if (hasLogin) {
        return;
      }

      if (!hashParams.userInfo || hashParams.userInfo === "") {
        this.showMobileBtn = true;
      } else {
        this.wtdecryptapi(hashParams.userInfo);
      }
    } else {
      // this.loadings()
      this.showMobileBtn = true;
    }

  },
  async mounted() {
    this.record({
      type: 8,
      resourceId: "",
    });
    var datas = await getNotice({noticeType: "2"});
    if (datas.data.code === "0") {
      this.notice_text = datas.data.data;
    }
  },
  methods: {


    parseHashParams() {
      const params = {};
      const hashString = window.location.hash.replace('#/', ''); // 去掉哈希部分的前缀
      const urlParams = new URLSearchParams(hashString.split('?')[1]);
      for (const [key, value] of urlParams) {
        params[key] = value;
      }
      return params;
    },

    wxRegCallback() {
    },
    selects(val, title) {
      this.list = [];
      this.hyList = [];
      this.shopList = [];


      // 切换tab项
      if (title === '商超代金券') {
        this.hyStatus = 0;
        this.fyActives = 0;
        this.fyFrom = 1;
        this.size = 10;
        this.couponGroup = 2;
        this.onfyLoad();
      } else if (title === '出行会员') {
        this.hyStatus = 0;
        this.fyActives = 0;
        this.fyFrom = 1;
        this.size = 10;
        this.couponGroup = 1;
        this.onfyLoad();
      } else if (title === '美食会员') {
        this.hyStatus = 0;
        this.fyActives = 0;
        this.fyFrom = 1;
        this.size = 10;
        this.couponGroup = 3;
        this.onfyLoad();
      } else if (title === '30元会员') {
        this.hyStatus = 0;
        this.fyActives = 0;
        this.fyFrom = 1;
        this.size = 10;
        this.couponGroup = 5;
        this.onfyLoad();
      } else if (title === '50元会员') {
        this.hyStatus = 0;
        this.fyActives = 0;
        this.fyFrom = 1;
        this.size = 10;
        this.couponGroup = 6;
        this.onfyLoad();
      }
    },
    async userinfos() {
      // this.finished=true
    },
    async getopenid(code) {
      const {data} = await getOauth2AccessTokenNew({
        code: code,
      });

      if (data.code == 0 && data.data) {
        this.openid = data.data;
        localStorage.setItem('openId', data.data);
        console.log("123213:" + data.data);
      }
    },
    async loginByOpenid() {
      if (!this.openid) {
        return false;
      }
      const {data} = await getTokenByOpenid({
        openid: this.openid,
      });
      if (data.code == 0 && data.data) {
        await this.loadingByToken(data);
        return true;
      }
      return false;
    },
    onRefresh() {
      console.log('进入了刷新')
      setTimeout(() => {
        this.refreshing = false;
      }, 1000);
      this.from = 0;
      this.list = [];
      this.fyFrom = 0;
      this.hyList = [];
      this.shopList = [];
      this.hyLoadings();
    },
    async onTelSet() {
      const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;

      if (this.tel === '' || this.tel === undefined || this.tel === null || !reg.test(this.tel)) {
        Dialog.alert({
          message: '手机号输入不正确，请检查',
        })
        return false
      }
      let param = {
        "mobile": this.tel,
        openid: this.openid,
      };
      const {data} = await wtdecrypt(param);
      this.loadingByToken(data);
    },
    async wtdecryptapi(userInfo) {
      console.log("sadasd:" + this.openid);
      // userInfo = 'R+JSr79J/UPcCR18iYSidU9qOLMJZG7F19erYXyOWEUYuqsDdtXuZKGBPnZ0sQeakGakH7u5y8Go7V+pOx2J3g==='
      let parma = {
        userInfo: userInfo.replaceAll(" ", "+"),
        openid: this.openid,
        // "openid": 'oGWjZs8LKqM7MJHpS-aZLryaTwMI',
      };
      const {data} = await wtdecrypt(parma);

      if (data.code === "500100") {
        Dialog.alert({
          message: "当前页面已失效，请重新进入当前页面",
        }).then(() => {
          // on close
        });

        return;
      }

      this.loadingByToken(data);


      //this.get_token(data.data);
    },

    async loadingByToken(data) {
      if (data.code != 0 || !data.data) {
        Dialog.alert({
          message: data.msg || "登录失败，请检查手机号",
        });
        return;
      }
      var dats = {
        token: data.data,
      };
      this.$store.dispatch("AddUser", dats).then(() => {
        if (localStorage.getItem("userArea") != null) {
          let res = JSON.parse(localStorage.getItem("userArea"));
          this.shows = res.id;
        }
      });
      // this.$store.commit('setUser', dats)

      var datas = await getuserInfo();

      console.log(datas.data.data.userType);
      this.userType = datas.data.data.userType;

      if (this.userType != "1") {
        Dialog.alert({
          title: "",
          message: "请到中国联通APP开通生活权益会员！",
        });
        return;
      }
      this.showMobileBtn = false;
      this.hyLoadings();
    },

    async get_token(mobile) {
      let param = {
        mobile: mobile,
      };

      const {data} = await getToken(param);

      if (data.code === 0) {
        var dats = {
          token: data.data,
        };
        this.$store.dispatch("AddUser", dats).then(() => {
          if (localStorage.getItem("userArea") != null) {
            let res = JSON.parse(localStorage.getItem("userArea"));
            this.shows = res.id;
          }
        });
        // this.$store.commit('setUser', dats)
      }

      var datas = await getuserInfo();

      console.log(datas.data.data.userType);
      this.userType = datas.data.data.userType;

      if (this.userType != "1") {
        Dialog.alert({
          title: "",
          message: "请到中国联通APP开通生活权益会员！",
        });
        return;
      }
      this.loadings();
    },
    // 出行会员 激活
    async hyActivated(id, activatedType) {
      Toast.loading({
        message: "激活中请稍等...",
        forbidClick: true,
      });

      let parma = {
        userCouponId: id,
        openId: activatedType === 0 ? '' : this.htOpenId,
      };
      const {data} = await fyActivatedCoupon(parma);

      Toast.clear();

      Dialog.alert({
        title: "",
        message: data.msg,
      }).then(() => {
        this.hyList = [];
        this.shopList = [];
        this.fyFrom = 0;
        this.hyLoadings();
      });
    },
    // 出行会员
    selectfyStatus(name, title) {
      if (title === '未使用') {
        this.hyStatus = 0;
      } else if (title === '已使用') {
        this.hyStatus = 2;
      } else if (title === '已失效') {
        this.hyStatus = 3;
      }
      this.fyFrom = 1;
      this.size = 10;
      this.couponGroup = 1;
      this.hyList = [];
      this.onfyLoad();
    },
    // 出行会员
    selectMsStatus(name, title) {
      if (title === '未使用') {
        this.hyStatus = 0;
      } else if (title === '已使用') {
        this.hyStatus = 2;
      } else if (title === '已失效') {
        this.hyStatus = 3;
      }
      this.fyFrom = 1;
      this.size = 10;
      this.couponGroup = 3;
      this.hyList = [];
      this.onfyLoad();
    },
    selectShopStatus(name, title) {
      if (title === '未使用') {
        this.hyStatus = 0;
      } else if (title === '已使用') {
        this.hyStatus = 2;
      } else if (title === '已失效') {
        this.hyStatus = 3;
      }
      this.fyFrom = 1;
      this.size = 10;
      this.couponGroup = 2;
      this.shopList = [];
      this.onfyLoad();
    },
    async loadings() {
      this.loading = true;
      this.from = this.from + 1;
      await this.onLoad();
      this.loading = false;
    },
    async hyLoadings() {
      this.hyLoading = true;
      this.fyFrom = this.fyFrom + 1;
      await this.onfyLoad();
      this.hyLoading = false;
    },

    // 缴费宝，出行会员领裙记录
    async onfyLoad() {
      console.log('出行会员页码', this.fyFrom);
      let parma = {
        from: this.fyFrom,
        size: this.size,
        status: this.hyStatus,
        couponGroup: this.couponGroup
      };
      const {data} = await getHyUserCoupons(parma);
      if (this.couponGroup !== 2) {
        if (JSON.stringify(data.data) === "[]") {
          this.hyLoading = true;
          this.hyFinished = true;
        } else {
          this.hyLoading = false;
          this.hyFinished = false;
        }
        if (JSON.stringify(this.hyList) === "[]") {
          this.hyList = data.data;
        } else {
          data.data.forEach((i, k) => {
            if (!i.couponUseDesc.includes('支付宝')) {
              this.hyList.push(i);
            }
          });
        }
      } else {
        if (JSON.stringify(data.data) === "[]") {
          this.shopLoading = true;
          this.shopFinished = true;
        } else {
          this.shopLoading = false;
          this.shopFinished = false;
        }
        if (JSON.stringify(this.shopList) === "[]") {
          this.shopList = data.data;
        } else {
          data.data.forEach((i, k) => {
            if (!i.couponUseDesc.includes('支付宝')) {
              this.shopList.push(i);
            }
          });
        }
      }

    }
  },
};
</script>

<style lang="less">
.home-container {
  .van-list {
    // height: calc(100vh - 4.2rem);
    // overflow: auto;
  }

  .navtab {
    .van-tab {
      font-size: 0.38rem;
    }

    .van-tab--active {
      font-weight: 700;
    }
  }

  .qy-content {
    position: relative;
    width: 100%;
    height: 2.8rem;

    background-size: 100% 100%;
    margin: 0.2rem 0;
    display: flex;
  }

  .qy-fen {
    background-image: url(../../assets/img/quanyifen.png);
  }

  .qy-hui {
    background-image: url(../../assets/img/qianyihui.png);
  }

  .qy-content-img {
    img {
      width: 1.8rem;
      height: 2.2rem;
      display: block;
      padding: 0.3rem 0.35rem;
    }
  }

  .qy-content-info {
    padding-top: 0.2rem;

    span {
      display: block;

      line-height: 0.8rem;
      margin-left: 0.5rem;

      &:nth-child(1) {
        font-size: 0.34rem;
        font-weight: 700;
      }

      &:nth-child(3) {
        font-size: 0.32rem;
        color: #cb4643;
      }
    }

    .transaction {
      font-size: .3rem;
      background: #ffe9e9;
      border-radius: 0.48rem;
      text-align: center;
      width: 2.5rem;
      color: #e60027;
    }

    .endTime {
      font-size: 0.32rem;
      color: #CB4643;
    }
  }

  .qy-button {
    width: 1rem;
    height: 100%;
    background-size: 100% 100%;
    position: absolute;
    right: 0.05rem;

    span {
      font-size: 0.38rem;
      display: block;
      width: 25%;
      color: #ffffff;
      text-align: center;
      margin: 0.8rem auto;
    }
  }

  .qy-button-fen {
    background-image: url(../../assets/img/quanyijihuo.png);
  }

  .qy-button-hui {
    background-image: url(../../assets/img/quanyiweijihuo.png);

    span {
      color: #999999 !important;
    }
  }
}
</style>
